$(function () {
  "use strict"
  const sidebarContent = $("#sidebar-content")

  function closeSidebar() {
    $("#nav-sidebar").removeClass("open")
    $("#open-sidebar").attr("aria-expanded", false)
    $("body").removeClass("apply-scroll-lock")
  }

  function trapFocus(e) {
    const elementsToFocus = $(
      "a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type='text']:not([disabled]), input[type='radio']:not([disabled]), input[type='checkbox']:not([disabled]), select:not([disabled])"
    )
    const focusableEls = sidebarContent.find(elementsToFocus)
    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]
    const KEYCODE_TAB = 9
    const isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB

    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      /* shift + tab */
      if (document.activeElement === firstFocusableEl) {
        lastFocusableEl.focus()
        e.preventDefault()
      }
    } else {
      /* tab */
      if (document.activeElement === lastFocusableEl) {
        firstFocusableEl.focus()
        e.preventDefault()
      }
    }
  }

  $("#open-sidebar").on("click", () => {
    $("#nav-sidebar").addClass("open")
    $("#open-sidebar").attr("aria-expanded", true)
    $("body").addClass("apply-scroll-lock")
  })

  $("#close-sidebar").on("click", closeSidebar)
  $("#nav-sidebar").on("click", closeSidebar)
  $(".hamburger-menu-close-button").on("click", closeSidebar)

  $("#sidebar-content").on("click", (e) => {
    e.stopPropagation()
  })

  sidebarContent.on("keydown", trapFocus)
})
